import React from "react";
import "../About/about.css"; // Import the CSS file
import Header from "../Header"; // Assuming this is your pre-built Header component
import Footer from "../Footer"; // Assuming this is your pre-built Footer component

const RulesAndRegulations = () => {
  return (
    <div className="about-education">
      <Header />
      <main className="content">
        <section className="hero">
          <img
            src="https://envs.sh/rw6.png"
            alt="Background"
            className="hero-image"
          />
          <div className="overlay">
          <h1 className="admission-title">
              Rules And<br />Regulations
            </h1>
          </div>
        </section>

        <section className="text-content">
            <h1><center><u>GENERAL RULES</u></center></h1>
        <ul>
  <li>
   <b> It is compulsory for students to:</b>
    <ul>
      <li>Carry their I-Card and diary every day.</li>
      <li>Ensure all communication between parents/guardians and teachers is made through the diary.</li>
    </ul>
  </li>
  {/* <li>
  <b>  While driving a motorized two-wheeler:</b>
    <ul>
      <li>People carry their driving license and wear a helmet.</li>
      <li>Park the vehicle in the school stand after obtaining a parking token.</li>
    </ul>
  </li> */}
  <li>
  <b> School uniform and personal grooming:</b>
    <ul>
      <li>Pupils must wear the prescribed uniform for the season on class days and school functions.</li>
      <li>Pupils should come to school clean and tidy.</li>
      <li>Pupils not dressed correctly or with improper appearance will be sent home as personal training.</li>
      <li>Persistent irregularity in uniform or punctuality may lead to withdrawal of the student.</li>
    </ul>
  </li>
  <li>
  <b> Attendance and punctuality:</b>
    <ul>
      <li>Latecomers or those absent on the previous day must bring a letter of explanation signed by parents and countersigned by the Principal.</li>
      <li>Leaving school premises during regular hours is strictly forbidden unless permitted by the Principal.</li>
    </ul>
  </li>
  <li>
  <b>  Disciplinary actions may be taken for:</b>
    <ul>
      <li>Irregular attendance, habitual idleness, or neglect of homework.</li>
      <li>Disobedience, disrespect towards school staff, or bad moral influence.</li>
    </ul>
  </li>
  <li>
  <b> Student conduct:</b>
    <ul>
      <li>Pupils must behave responsibly on their way to and from school.</li>
      <li>Bringing objectionable literature, mobile phones, or electronic gadgets to school is strictly forbidden.</li>
      <li>During a teacher’s absence, pupils must follow the instructions of the appointed monitor.</li>
    </ul>
  </li>
  <li>
  <b> School property:</b>
    <ul>
      <li>Any damage to school premises, furniture, or fixtures will be charged to the responsible student.</li>
    </ul>
  </li>
  <li>
  <b> Parental cooperation:</b>
    <ul>
      <li>Parents should ensure regularity, discipline, and interest in their child’s progress.</li>
      <li>Encourage participation in co-curricular and extra-curricular activities.</li>
    </ul>
  </li>
  <li>
  <b> Health and safety:</b>
    <ul>
      <li>A fitness certificate is required for a student recovering from or exposed to infectious diseases.</li>
    </ul>
  </li>
  <li>
  <b>  Private tuition:</b>
    <ul>
      <li>Private tutors should only be employed in exceptional cases with prior permission from the Principal.</li>
      <li>Teachers are not allowed to tutor students from their own classes.</li>
    </ul>
  </li>
  <li>
  <b>  School diary and updates:</b>
    <ul>
      <li>A school diary is published annually and contains updated rules and regulations.</li>
      <li>Each student must possess a copy of the diary.</li>
    </ul>
  </li>
  <li>
  <b>Transfer certificates:</b>
    <ul>
      <li>Duplicate copies of Transfer Certificates are issued only in special cases with proof verification and permission from the Inspector of Anglo-Indian Schools, U.P., on payment of Rs.500/-.</li>
    </ul>
  </li>
  <li>
  <b>  Co-curricular and extra-curricular activities:</b>
    <ul>
      <li>Participation in these activities is compulsory when required by the school authorities.</li>
    </ul>
  </li>
  <li>
  <b> Visitors:</b>
    <ul>
      <li>Parents, relatives, guardians, or friends must seek prior permission from the Principal to meet teachers, students, or enter classrooms.</li>
    </ul>
  </li>
</ul>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default RulesAndRegulations;
